export default __webpack_public_path__ + "static/media/header.67166702.png";